import { ISaveSearchProps } from '@cian/save-search-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { LocationSubscription } from '../../components/LocationSubscription';
import { SaveSearchModal } from '../../components/SaveSearchModal';
import { offerSelector, selectUser } from '../../selectors';
import { subdomainSelector } from '../../selectors/pageData/dump/subdomainSelector';
import { useApplicationContext } from '../ApplicationContext';
import { trackSubscribed, trackSubscriptionModalClose, trackSubscriptionModalOpen } from './tracking';
import { getJsonQuery } from './utils';

export const LocationSubscriptionContainer = () => {
  const [open, setOpenModal] = React.useState<boolean>(false);
  const { httpApi, logger } = useApplicationContext();
  const subdomain = useSelector(subdomainSelector);
  const offer = useSelector(offerSelector);
  const user = useSelector(selectUser);
  const jsonQuery = React.useMemo(() => getJsonQuery(offer), [offer]);
  const defaultTitle = React.useMemo(() => {
    const addressWithoutStreet = offer.geo.address.filter(
      addr => addr.type === 'raion' || addr.type === 'okrug' || addr.type === 'location',
    );

    return addressWithoutStreet.map(a => a.shortName).join(', ');
  }, [offer.geo.address]);
  const userEmail = user?.isAuthenticated ? user.email : null;

  const handleOnSubscribed = React.useCallback(
    (parameters: Parameters<Required<ISaveSearchProps>['onSubscribed']>[0]) => {
      trackSubscribed({
        frequency: parameters.frequency,
        subscribeToNews: parameters.subscribeToNews,
        title: parameters.title,
        email: parameters.email,
        defaultTitle,
        defaultEmail: userEmail,
        offerId: offer.id,
      });

      /* istanbul ignore next */
      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }
    },
    [defaultTitle, offer.id, userEmail],
  );

  const openModal = React.useCallback(() => {
    trackSubscriptionModalOpen();

    setOpenModal(true);
  }, []);

  const closeModal = React.useCallback(() => {
    trackSubscriptionModalClose();

    setOpenModal(false);
  }, []);

  return (
    <>
      <LocationSubscription onClick={openModal} />
      <SaveSearchModal
        open={open}
        onClose={closeModal}
        httpApi={httpApi}
        logger={logger}
        subdomain={subdomain}
        jsonQuery={jsonQuery}
        defaultTitle={defaultTitle}
        userEmail={userEmail}
        hideLicense={!!user?.isAuthenticated}
        onSubscribed={handleOnSubscribed}
        modalTitle="Подписаться на локацию"
        customSubmitButtonText="Подписаться"
      />
    </>
  );
};
